import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Timeoff } from '../types/entities';

interface TimeoffDeleteConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  timeoff: Timeoff | null;
}

const TimeoffDeleteConfirmationDialog: React.FC<TimeoffDeleteConfirmationDialogProps> = ({
  open,
  onClose,
  onConfirm,
  timeoff,
}) => {
  const { t } = useTranslation();

  if (!timeoff) return null;

  const formatDateTime = (date: Date) => {
    return new Date(date).toLocaleString('pl-PL', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('timeoffs.deleteTimeoff')}</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography variant="body1">
            {t('dialogs.confirmDelete')}
          </Typography>
          
          <Box sx={{ p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              {t('common.hairdresser')}: {timeoff.hairdresser?.name || t('common.notAvailable')}
            </Typography>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              {t('timeoffs.startDate')}: {formatDateTime(timeoff.startDate)}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {t('timeoffs.endDate')}: {formatDateTime(timeoff.endDate)}
            </Typography>
          </Box>
          
          <Typography variant="body2" color="error">
            {t('dialogs.thisActionCannotBeUndone')}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          {t('common.cancel')}
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained">
          {t('common.delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TimeoffDeleteConfirmationDialog;
